import { FONT_TYPE, STATIC_TYPE, KEYFRAME_TYPE, RULE_TYPE } from './styleTypes';
export default {
  fontFaces: FONT_TYPE,
  statics: STATIC_TYPE,
  keyframes: KEYFRAME_TYPE,
  rules: RULE_TYPE
};